"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth-context";
import { apiGet } from "@/lib/api";
import BrokersMenu from "@/components/brokers-menu";
import DiagnosticMenu from "@/components/diagnostic-menu";

function NavLink({ href, label, badge, prefixMatch }: { href: string; label: string; badge?: boolean; prefixMatch?: boolean }) {
  const pathname = usePathname();
  const active = prefixMatch ? pathname.startsWith(href) : pathname === href;
  return (
    <Link
      href={href}
      className={`transition-colors no-underline ${
        active
          ? "text-white [text-shadow:0_0_8px_#fff,0_0_16px_#fff,0_0_30px_var(--color-accent),0_0_50px_var(--color-accent)]"
          : "text-muted hover:text-accent"
      }`}
    >
      {badge && <span className="text-amber mr-0.5">•</span>}
      {label}
    </Link>
  );
}

export default function NavLinks() {
  const { user, isSudo } = useAuth();
  const [unreconciledCount, setUnreconciledCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    apiGet<{ count: number }>("/statements/unreconciled-count")
      .then((r) => setUnreconciledCount(r.count))
      .catch(() => {});
  }, [user]);

  if (!user) return null;

  return (
    <div className="flex items-center gap-4 text-sm">
      <BrokersMenu />
      <NavLink href="/accounts" label="Accounts" />
      <NavLink href="/trades" label="Trades" />
      <NavLink href="/prices" label="Prices" />
      <DiagnosticMenu />
      <NavLink href="/statements" label="Statements" badge={unreconciledCount > 0} />
      <NavLink href="/my-config" label="My Config" />
      {isSudo && <NavLink href="/admin" label="Admin" />}
      <NavLink href="/user-guide" label="User Guide" prefixMatch />
      <NavLink href="/documentation" label="Documentation" prefixMatch />
      <NavLink href="/videos" label="Videos" />
    </div>
  );
}
